export default "__VITE_ASSET__DNn7huel__"